import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import i18n from './i18n/i18n.js'
import store from './store'
import md5 from 'js-md5'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Print from 'vue-print-nb'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import './assets/iconfont/iconfont.css'
import echarts from 'echarts'
import './assets/iconfont/iconfont.js'
import './assets/font/font.css'
import VueLazyLoad from "vue-lazyload"
// import Print from './plugs/print.js'
import '@assets/scss/index.scss';
import vueToPdf from 'vue-to-pdf';
import '@assets/fonts/iconfont.css'
import animated from 'animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { showLoading, hideLoading } from './assets/js/loading.js';
import dxsCell from './components/base/dxs-cell'


import {Toast ,ActionSheet  ,Lazyload  ,SwipeItem,Button , Swipe,CellGroup ,Cell,Tab, Tabs,DropdownMenu, DropdownItem ,
	 NavBar ,SubmitBar,Radio,Popup,Badge,Stepper,Tag ,RadioGroup,Loading ,PullRefresh, Field, Dialog ,Tabbar , Empty,  TabbarItem ,GoodsAction, GoodsActionIcon, GoodsActionButton ,Sku ,AddressEdit } from 'vant'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper)




const showMessage = Symbol('showMessage')


// Vue.prototype.$VERSION = VERSION;
Vue.use(VueDirectiveImagePreviewer) 
Vue.use(animated)
Vue.use(ElementUI)
Vue.use(showLoading)
Vue.use(hideLoading)
Vue.use(DropdownMenu)
Vue.use(GoodsAction)
Vue.use(Loading )
Vue.use(GoodsActionButton)
Vue.use(GoodsActionIcon)
Vue.use(AddressEdit);
Vue.use(DropdownItem)
Vue.use(Tab)
Vue.use(Tag)
Vue.use(Sku)
Vue.use(Tabs)
Vue.use(Badge)

Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Empty)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Radio)
Vue.use(Stepper)
 
Vue.use(RadioGroup)
Vue.use(ActionSheet)
Vue.use(SwipeItem)
Vue.use(Swipe)
Vue.use(Lazyload)
Vue.use(NavBar)
Vue.use(SubmitBar);
Vue.use(PullRefresh);
Vue.use(VueAwesomeSwiper)
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Print)
Vue.prototype.$md5 = md5
Vue.use(vueToPdf)
Vue.prototype.$axios = axios;


Vue.component('dxsCell',dxsCell)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.showLoading=showLoading
Vue.prototype.hideLoading=hideLoading
Vue.prototype.indexValue = function (arr,key) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] == key) {
			return i;
		}
	}
	
}
Vue.prototype.bus = new Vue;
Vue.prototype.showLoadingbase= function (val) {
	this.bus.$emit('loading', true,val);
  }
  
  Vue.prototype.hideLoadingbase= function (val) {
	this.bus.$emit('loading', false,val);
  }

axios.defaults.headers.post['Content-Type'] = 'application/json'




new Vue({
	i18n,
	router,
	store,
  render: h => h(App),
}).$mount('#app')
